import Swiper, { Navigation } from 'swiper';

export default class Slider {
	constructor(sliderElement) {

        const options = {
            direction: 'horizontal',
            slidesPerView: 1.2,
            spaceBetween: 20,
            lazy: true,
            speed: 1000,
            keyboard: true,

            breakpoints: {
				576: {
					slidesPerView: 1.4,
                    spaceBetween: 40,
				},
				1080: {
					slidesPerView: 2,
                    centeredSlides: true,
                    loop: true,
                    spaceBetween: 40,
				},

			},
        };

        this.swiper = new Swiper(sliderElement, options);
	}
}
